import { render, staticRenderFns } from "./roomInfoScreen.vue?vue&type=template&id=6da15608&scoped=true&"
import script from "./roomInfoScreen.vue?vue&type=script&lang=js&"
export * from "./roomInfoScreen.vue?vue&type=script&lang=js&"
import style0 from "./roomInfoScreen.vue?vue&type=style&index=0&id=6da15608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da15608",
  null
  
)

export default component.exports